import {CurrencyFormatter} from '@fantasmagames/core/src/utils/CurrencyFormatter';

export class RecodeCurrencyFormatter extends CurrencyFormatter {
	protected _currencyAvailableOnAPI: boolean = true;
	private _useApiFormatter: boolean = false;

	constructor() {
		super();
		const displayFormat = (window as any).V.API.Core.getCasinoState().player.currencyDisplayFormat;
		const isoCode = (window as any).V.API.Core.getCasinoState().player.currencyIsoCode;

		if (displayFormat === '####.##') {
			this._currencyAvailableOnAPI = false;
			// Special case for IDR currency : Indonesian Rupiah-
			this.setINDCurrency(isoCode, displayFormat);

			return;
		}

		this.setCurrencyData(this.parseCurrencyFormatting(isoCode, displayFormat));
	}

	public formatCurrencyApi(value: number): string {
		if (this._currencyAvailableOnAPI) {
			return (window as any).V.API.Core.convertCurrency(value);
		}

		return this.formatCurrency(value / 100, true);
	}

	public formatCurrency(value: number, showCurrencySign: boolean): string {
		if (this.useApiFormatter) {
			return this.formatCurrencyApi(value);
		}

		const result = super.formatCurrency(value, showCurrencySign);

		return result;
	}

	protected setINDCurrency(isoCode: string, displayFormat: string): void {
		this.currency = isoCode;
		this.currencyDecimals = 2;
		this.thousandSeparator = '';
		this.decimalSeparator = '.';
		this.currencyPrefix = '';
		this.currencySuffix = '';
		// this.currencySign = dataObject[1] ? dataObject[1] : '';
		this.currencySign = this.currencyPrefix;
	}

	public set useApiFormatter(v: boolean) {
		this._useApiFormatter = v;
	}

	public get useApiFormatter(): boolean {
		return this._useApiFormatter;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/utils/RecodeCurrencyFormatter.ts